import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import moment from 'moment'
import Vuelidate from 'vuelidate'

// dodato za moment
moment.locale('sr') // serbian

// dodato za buefy
import Buefy from 'buefy'
//import 'buefy/dist/buefy.css'
Vue.use(Buefy, {
  defaultIconPack: 'fas',
  defaultDateFormatter: date => moment(date).format('L') // za dateppicker
})

// dodato za fontawesome
import '@fortawesome/fontawesome-free/css/all.min.css'

// dodato za progressbar
import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px'
})

// dodato za Vuelidate
Vue.use(Vuelidate)
Vue.config.productionTip = false

export default new Vue({
  router,
  store,
  // automatic login (07 Automatic Login - Token-Based Authentication _ Vue Mastery)
  created() {
    // ovo je isto kao u modulu auth
    const userString = localStorage.getItem('user')
    console.log(userString)
    if (userString) {
      const userData = JSON.parse(userString)
      this.$store.commit('auth/SET_USER_DATA', userData)
    }
    // Adding a Security Measure
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          this.$steore.dispatch('logout')
        }
        return Promise.reject(error)
      }
    )
  },
  render: h => h(App)
}).$mount('#app')
